import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@components/ui/alert';
import { OverlapScheduleDialogProps } from '../types';
import { InternalScheduleActionDialogActions } from '../actions';
import { PublishScheduleConfirmationConflicts } from '../../publish/confirmation/conflicts';
import { ActionSheet } from '@components/scheduling/actionSheet';

export const OverlapScheduleDialog = ({
  open,
  setOpen,
  onCancel,
  onConfirm,
  disabled,
  conflicts,
  name,
  summaryDetail,
  date,
  sheet,
}: OverlapScheduleDialogProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'overlappingSchedules' });

  const conflictsList = (
    <PublishScheduleConfirmationConflicts
      conflicts={conflicts}
      name={name}
      summaryDetail={summaryDetail}
      date={date}
    />
  );
  const actions = (
    <InternalScheduleActionDialogActions
      type="overlap"
      onCancel={() => {
        setOpen(false);
        onCancel();
      }}
      onConfirm={() => {
        setOpen(false);
        onConfirm();
      }}
      disabled={disabled}
    />
  );

  if (sheet)
    return (
      <ActionSheet
        open={open}
        onDismiss={() => {
          setOpen(false);
          onCancel();
        }}
        title={t('title')}
        description={t('description')}
        actions={actions}>
        {conflictsList}
      </ActionSheet>
    );

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('description')}</AlertDialogDescription>
        </AlertDialogHeader>
        {conflictsList}
        <AlertDialogFooter>{actions}</AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
